import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertController, IonicPage, NavController } from 'ionic-angular';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { BaseComponent } from '../../../core/components/base.component';
import { ConfigQueries } from '../../business-objects/config/config.queries';
import { User } from '../../business-objects/user/user.model';
import { VasAppFacade } from '../../services/vas-app-facade.service';
import { LoginController } from './login.controller';
import { ENV } from '../../../environments/environment';

@IonicPage()
@Component({
    selector: 'page-login',
    templateUrl: 'login.html',
    viewProviders: [
        {
            provide: LoginController,
            useClass: LoginController,
            deps: [
                VasAppFacade,
                AlertController
            ]
        }
    ]
})
export class LoginPage extends BaseComponent {

    userForm: FormGroup;
    versionNumber: string;
    apiUrl: string;

    constructor(
        protected appFacade: VasAppFacade,
        protected navController: NavController,
        protected controller: LoginController
    ) {
        super();
    }

    ngOnInit(): void {

        this.userForm = new FormGroup({
            email: new FormControl('', Validators.required),
            password: new FormControl('', Validators.required)
        });

        this.appFacade.meta.getAppVersion()
            .take(1)
            .subscribe(
                value => this.versionNumber = value,
                error => {
                    console.log(error);
                    this.versionNumber = 'n/a';
                }
            );

        combineLatest(
            this.appFacade.store.select(ConfigQueries.getRestHost),
            this.appFacade.store.select(ConfigQueries.getRestEndpoint)
        )
            .takeUntil(this.ngUnsubscribe)
            .subscribe(args => {
                this.apiUrl = args.join('');
            });

        /**
         *
         * @param email
         * @param password
         */
        (window as any).vasLogin = (email, password) => {

            this.appFacade.auth.login(email, password).then(
                (user: User) => {
                    this.navController.setRoot('AccountsPage');
                },
                error => {
                    console.error(error);
                }
            );
        };
    }

    getFormData(): any {
        return this.userForm.value;
    }

    onSubmit(): void {
        const data = this.getFormData();

        this.appFacade.auth.login(data.email, data.password).then(
            (user: User) => {
                this.navController.setRoot('AccountsPage');
            },
            error => {
                console.error(error);
            }
        );
    }

    onClickApiUrl(): void {
        this.controller.showUpdateHostDialog();
    }

    disableRegister(): boolean {
        return ENV.disableRegister;
    }

    onSignup(): void {

        // if (this.restService.isOnline()) {
        //     this.pushPage("signup");
        // } else {
        //     this.toast("SIGN_UP_UNAVAILABLE_WHILE_OFFLINE");
        // }
    }

    getVersion(): string {
        return this.versionNumber;
    }

    getApiUrl(): string {
        return this.apiUrl || (this.appFacade.config.REST.HOST + this.appFacade.config.REST.ENDPOINT);
    }
}



// WEBPACK FOOTER //
// ./src/vas/pages/login/login.ts